import { VISUAL } from "../config/visualConfig";
import type { Game } from "../game/Game";
import type { Layer } from "../game/types";
import { layerSwitchEase } from "./layerSwitchEase";

type SwapState = Pick<Game, "foregroundLayer" | "isLayerSwitching" | "layerSwitchProgress">;

/** Move the entire colored board, including its stack and housing. */
export function layerZ(game: SwapState, layer: Layer): number {
  const target = (layer === game.foregroundLayer ? 1 : -1) * VISUAL.layerDepth / 2;
  return game.isLayerSwitching ? target * (2 * layerSwitchEase(game.layerSwitchProgress) - 1) : target;
}

export function layerSeparation(game: SwapState): number {
  return Math.abs(layerZ(game, "front") - layerZ(game, "back"));
}
